export { default, default as ErrorMessage } from "./ErrorMessagePassword";
